import { Cover, COVER_TYPE_IMAGE } from './Cover'

/*
  Историческая обложка: две загруженные пользователем картинки.
  Остаётся поведением по умолчанию для всех проектов без cover.type.
*/
class ImageCover extends Cover {
  get type () {
    return COVER_TYPE_IMAGE
  }

  get left () {
    return this.data.left || ''
  }

  get right () {
    return this.data.right || ''
  }

  isComplete () {
    return Boolean(this.left) && Boolean(this.right)
  }
}

export { ImageCover }
